import { useNavigate } from "react-router-dom";

import { MainButton } from "../../../../../components/button";
import { useEntryAuthWall } from "../../hooks/useAuthWall";
import Panel from "../../Panel";
import { Heading, Intro } from "../../Typography";
import {
  AddButton,
  CompetitorList,
  CompetitorListItem,
} from "./CompetitorList";
import useCompetitorListScreen from "./useCompetitorListScreen";

const CompetitorListScreen = () => {
  const { competitors, onSubmit, isSubmitting, isJudge } =
    useCompetitorListScreen();
  const navigate = useNavigate();

  useEntryAuthWall();

  return (
    <Panel>
      <Heading>Register Competitors</Heading>
      <Intro>Add or edit competitors here</Intro>

      <CompetitorList>
        {competitors.map(({ profile, category }) => (
          <CompetitorListItem
            onClick={() => navigate(profile.uuid)}
            profile={profile}
            key={profile.uuid}
            category={category}
          />
        ))}
        <AddButton onClick={() => navigate("add", { state: { isJudge } })} />
      </CompetitorList>
      {competitors.length ? (
        <MainButton
          onClick={onSubmit}
          className="mt-4"
          isSubmitting={isSubmitting}
        >
          {competitors.length
            ? `Enter ${competitors.length} competitors`
            : "Enter competition"}
        </MainButton>
      ) : null}
    </Panel>
  );
};

export default CompetitorListScreen;
